import { useSelector } from 'react-redux';

import {
  selectFeaturedProducts,
  selectIsFeaturedProductsLoading,
  selectIsProductsRequestLoading,
  selectLastDataLoadedTime,
  selectLastFeaturedProductsLoadedTime,
  selectProductsDataCount,
  selectProductsDataResults,
} from '@lib/core/products/selectors/searchCatalog';

export const useSearchCatalog = () => ({
  featuredProducts: useSelector(selectFeaturedProducts),
  isFeaturedProductsLoading: useSelector(selectIsFeaturedProductsLoading),
  isProductsRequestLoading: useSelector(selectIsProductsRequestLoading),
  itemsCount: useSelector(selectProductsDataCount),
  lastDataLoadedTime: useSelector(selectLastDataLoadedTime),
  lastFeaturedProductsLoadedTime: useSelector(selectLastFeaturedProductsLoadedTime),
  products: useSelector(selectProductsDataResults),
});
